import type { ParentCategory } from '@library/menu-service'

import type { MenuParentCategoriesState } from 'reducers/menu-parentcategories/menuParentCategories'

const NO_PARENT_CATEGORIES: ParentCategory[] = []

export const getParentCategories = ({ menuV3ParentCategories }: MenuParentCategoriesState) =>
  menuV3ParentCategories?.parentCategories || NO_PARENT_CATEGORIES
